import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/21_card_back_orchids/21_card_back_orchids"
 * Contains 1 texture(s)
 */
export class CardsBacks21CardBackOrchidsAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/21_card_back_orchids/21_card_back_orchids';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '21_orchids.png'
    ] as const;
}
